import { Observable } from "rxjs"
import { AccountTypeID } from "../../config/Constants"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function RandomSelectionListCsvGetObservable(poolId: number, poolSelectionId: number, poolName: string, accountId: number): Observable<string> {
  const params: string = JSON.stringify({
    Extra: "false",
    PageSize: 25,
    PoolID: poolId,
    AccountID: accountId,
    PoolMembersID: [],
    PoolName: poolName,
    PoolSelectionID: poolSelectionId,
    ProfileAccountTypeID: AccountTypeID
  })

  return ObservableFromFetch<string>("RandomTest/RandomSelectionListExport", params)
}

